// TopError is a class that is added by userforms module.
// This validation function is required due to top errors that are displayed.
const removeTopErrorMessage = (errorMessageId) => {
    // Replace the last part of the error message ID (-error)
    // by -top-error to identify the specific top error
    // that should be hidden
    const partsErrorMessageID = errorMessageId.split('-');
    partsErrorMessageID.pop();
    const fieldID = partsErrorMessageID.join('-');
    const topErrorID = `#${fieldID}-top-error`;
    $(topErrorID).removeClass('d-block').addClass('d-none');
};

// display top errors is a userforms module element
const addTopErrorMessage = (fieldID) => {
    // Add -top-error to error message ID to identify the specific top error
    // that should be displayed
    const topErrorID = `${fieldID}-top-error`;
    $(`#${topErrorID}`).removeClass('d-none');
};

export const formatSelectValidation = (selector) => {
    $(selector).each(function () {
        // Modify the style of the original select element to show it for the
        // default form validation to validate the field
        // Hidden or display none elements are not validated
        $(this).css(
            {
                display: 'block', height: '0', border: '0', padding: 0, boxShadow: 'none',
            },
        );
        const selectmenuButton = $(this).siblings('.ui-selectmenu-button');
        // the error message needs to be placed after the custom dropdown element
        // moving the select element after the custom dropdown element avoids
        // showing a brief jump as the error message is moved
        $(this).insertAfter(selectmenuButton);
        // Dropdown field validation - change event
        $(this).on('selectmenuchange', function () {
            const selectmenuErrorMessage = $(this).next();
            selectmenuErrorMessage.removeClass('d-block').addClass('d-none');
            selectmenuErrorMessage.removeClass('error');
            selectmenuButton.css({ borderColor: '#dfe0e3' });
            const dropdownErrorMessageID = selectmenuErrorMessage.attr('id');
            if (dropdownErrorMessageID !== undefined) {
                // Hide top error when user selects an option
                // on the dropdown field
                removeTopErrorMessage(dropdownErrorMessageID);
            }
        });
    });
};

export const formatRecaptchaErrorMessage = (selector) => {
    // select the p element that will contain the reCaptcha error message when it is not valid
    // This p element will be the first p child (with message class)
    // of his parent (form element with userform class)
    $(selector).children('p.message:first').addClass('recaptchaError error');
    $('.recaptchaError').insertAfter($('#recaptcha-field'));
};

const validateUserformRequiredFields = () => {
    let areRequiredFieldsValid = false;
    $('.userform [required]').each(function () {
        areRequiredFieldsValid = $(this).val() !== '';
        return areRequiredFieldsValid;
    });

    return areRequiredFieldsValid;
};

export const validateRecaptcha = (e) => {
    // return false when required fields are not valid
    if (!validateUserformRequiredFields()) {
        return false;
    }
    // return true when required fields and reCaptcha are valid
    if ($('#g-recaptcha-response').val() !== '') {
        return true;
    }
    // prevent form submission when the reCaptcha is the only field that is not valid
    e.preventDefault();
    const recaptchaErrorMessage = $('.recaptchaError');
    recaptchaErrorMessage.empty();
    recaptchaErrorMessage.text('reCAPTCHA field is required').css({ display: '' }).toggleClass('d-block');
    return false;
};

export const formatInvalidDropdownFields = () => {
    // setTimeout is needed to allow silverstripe userforms package to validate
    // fields after which we can modify the styles
    setTimeout(function () {
        // find span that contains error message with class error
        const selectmenuErrors = $('.form-step').find('span.error');
        selectmenuErrors.each(function (index, selectmenuError) {
            const selectmenuErrorParent = $(selectmenuError).parent();
            const selectmenuDropdown = selectmenuErrorParent.find('.ui-selectmenu-button');
            selectmenuDropdown.css({ borderColor: '#d2232a' });
            $(selectmenuError).removeClass('d-none').addClass('d-block');
            const dropdownErrorMessageID = $(selectmenuError).attr('id');
            // display the top error when dropdown field is not valid
            addTopErrorMessage(dropdownErrorMessageID);
        });
    }, 100);
};

export const hideRecaptchaError = (response) => {
    if (!response) {
        return;
    }
    $('.recaptchaError').removeClass('d-block').addClass('d-none');
};

window.recaptchaCallback = hideRecaptchaError;
